// Übersetzungen [Suomi, English] der Taktik-Rätsel und ihrer Themen.
export const PUZZLE: Record<string, [string, string]> = {
  'Taktik': ['Taktiikka', 'Tactics'],
  'Rätsel nahe deiner Stärke, wahlweise zu einem Thema.': ['Tehtäviä tasosi mukaan, halutessasi teeman mukaan.', 'Puzzles near your strength, optionally by theme.'],
  'Deine Rätsel-Wertung': ['Tehtäväluokituksesi', 'Your puzzle rating'],
  'Thema': ['Teema', 'Theme'],
  'Alle Themen': ['Kaikki teemat', 'All themes'],
  'Rätsel-Wertung {r}': ['Tehtävän luokitus {r}', 'Puzzle rating {r}'],
  'Deine Wertung: {d}': ['Luokituksesi: {d}', 'Your rating: {d}'],
  'Deine Wertung: {d} (der erste Versuch zählt)': ['Luokituksesi: {d} (ensimmäinen yritys ratkaisee)', 'Your rating: {d} (the first try counts)'],
  'Rätsel wird geladen …': ['Tehtävää ladataan …', 'Loading puzzle …'],
  'Das ist nicht die Lösung. Noch ein Versuch?': ['Se ei ole ratkaisu. Yritätkö uudelleen?', 'That is not the solution. Try again?'],
  'Gelöst!': ['Ratkaistu!', 'Solved!'],
  'Lösung gezeigt.': ['Ratkaisu näytetty.', 'Solution shown.'],
  'Finde den besten Zug für {s}.': ['Etsi paras siirto: {s}.', 'Find the best move for {s}.'],
  'Der Gegner zieht …': ['Vastustaja siirtää …', 'The opponent is moving …'],
  'Rätsel': ['Tehtävä', 'Puzzle'],
  'Rätsel aus der lichess-Datenbank (gemeinfrei, CC0).': ['Tehtävät lichessin tietokannasta (vapaa käyttö, CC0).', 'Puzzles from the lichess database (public domain, CC0).'],
  'Nächstes Rätsel': ['Seuraava tehtävä', 'Next puzzle'],
  'Nochmal laden': ['Lataa uudelleen', 'Load again'],
  'Kein Rätsel zu diesem Thema': ['Tähän teemaan ei ole tehtäviä', 'No puzzle for this theme'],
  // Themen
  'Matt in 1': ['Matti yhdellä', 'Mate in 1'],
  'Matt in 2': ['Matti kahdella', 'Mate in 2'],
  'Matt in 3': ['Matti kolmella', 'Mate in 3'],
  'Grundreihenmatt': ['Takarivimatti', 'Back rank mate'],
  'Ersticktes Matt': ['Tukehdutusmatti', 'Smothered mate'],
  'Gabel': ['Haarukka', 'Fork'],
  'Fesselung': ['Kiinnitys', 'Pin'],
  'Spieß': ['Varras', 'Skewer'],
  'Abzugsangriff': ['Paljastushyökkäys', 'Discovered attack'],
  'Doppelschach': ['Kaksoisshakki', 'Double check'],
  'Opfer': ['Uhraus', 'Sacrifice'],
  'Ungedeckte Figur': ['Suojaamaton nappula', 'Hanging piece'],
  'Gefangene Figur': ['Ansaan jäänyt nappula', 'Trapped piece'],
  'Ablenkung': ['Harhautus', 'Deflection'],
  'Hinlenkung': ['Houkutus', 'Attraction'],
  'Zwischenzug': ['Välisiirto', 'Intermezzo'],
  'Räumung': ['Raivaus', 'Clearance'],
  'Verstellung': ['Väliintulo', 'Interference'],
  'Röntgenangriff': ['Röntgenhyökkäys', 'X-ray attack'],
  'Verteidiger schlagen': ['Puolustajan lyönti', 'Capturing the defender'],
  'Königsangriff': ['Kuninkaansiiven hyökkäys', 'Kingside attack'],
  'Ungeschützter König': ['Suojaton kuningas', 'Exposed king'],
  'Stiller Zug': ['Hiljainen siirto', 'Quiet move'],
  'Verteidigung': ['Puolustus', 'Defensive move'],
  'Zugzwang': ['Siirtopakko', 'Zugzwang'],
  'Umwandlung': ['Korotus', 'Promotion'],
  'Weit vorgerückter Bauer': ['Pitkälle edennyt sotilas', 'Advanced pawn'],
  'Mittelspiel': ['Keskipeli', 'Middlegame'],
  'Endspiel': ['Loppupeli', 'Endgame'],
  'Turmendspiel': ['Tornipääte', 'Rook endgame'],
  'Bauernendspiel': ['Sotilaspääte', 'Pawn endgame'],
};
